import { Button } from '@mui/material';
import { getPatient, listPatients } from '@/graphql/queries';
import { createReception } from '@/graphql/mutations';
import { ComponentPropsWithoutRef } from 'react';
import { graphqlOperation } from '@aws-amplify/api-graphql';
import { executeQuery } from '@/lib/glaphqlClient';

function Call({ className }: ComponentPropsWithoutRef<'div'>) {
  const test = async () => {
    const getPatientResponse = await executeQuery(getPatient, { id: 'a7148ad8-3071-701d-108d-3e294d4a0af8' }, 'iam');
    if (!getPatientResponse.result) {
      return;
    }

    const receptionResponse = await executeQuery(
      createReception,
      {
        input: {
          patientId: 'a',
          date: 'a',
          outpatientId: 'a',
          outpatientName: 'a',
          startTime: 'a'
        }
      },
      'iam'
    );
    if (!receptionResponse.result) {
      return;
    }

    const fetchPatientsByKarteNo = async (karteNo: string) => {
      const filter = {
        karteNo: {
          eq: karteNo
        }
      };
      const response = await executeQuery(listPatients, filter, 'iam');
      if (!response.result) {
        return;
      }
    };
    fetchPatientsByKarteNo('12345');
  };
  return (
    <div className={`flex justify-center ${className}`}>
      <Button
        className="bg-transparent text-primary border-primary rounded-lg px-10 py-2 text-lg sm:text-xl"
        sx={{ border: 1 }}
        onClick={() => test()}
      >
        スタッフを呼ぶ
      </Button>
    </div>
  );
}

export default Call;
